import React from "react";
import PhotoAlbum2 from "../components/PhotoAlbum2";
import Navbar from "../components/Navbar";

const Performance = () => {
  return (
    <>
      <Navbar />
      <div
        id="section3"
        style={{
          textAlign: "center",
          color: "white",
          backgroundColor: "black",
          marginTop: "5em",
        }}
      >
        <PhotoAlbum2 />
      </div>
    </>
  );
};

export default Performance;
